/**
 * 주일 오후예배 설교 페이지
 */

import React from 'react';
import { SermonList } from '../components/SermonList';

export const SundayEveningSermon: React.FC = () => {
  return <SermonList sermonType="sunday-evening" title="주일 오후예배" />;
};
